import React from "react";
import Icon from "../../aat/components/Icon/Icon";
import { CustomIcon, CustomIconNoHide } from "./Styles";
import { invert } from "polished";

export interface LoginButtonProps {
    textColor: string;
    navigateToLogIn: () => void;
    isLoggedIn: boolean;
}

export default function LoginButton(props: LoginButtonProps): JSX.Element {
    const { textColor, navigateToLogIn, isLoggedIn } = props;
    React.useState(0);
    return (
        <button className="app-bar__btn-login" style={{ color: textColor }} onClick={navigateToLogIn}>
            {isLoggedIn ? (
                <CustomIconNoHide>
                    <Icon name="login" />
                </CustomIconNoHide>
            ) : (
                <>
                    <CustomIcon>
                        <Icon name="login" />
                    </CustomIcon>
                    <span className="app-bar__btn-login-title">{"Login"}</span>
                </>
            )}
        </button>
    );
}
